__turbopack_context__.v({
  "IconButton": "search-module__yVK7wa__IconButton",
});
